/**
 * Показать тост в layout organization.vue.
 * Не использовать this.$root.$emit — в Nuxt у страниц другой $root, чем у layout (composition API).
 */
export function emitOrgToast(
  text,
  type = 'info',
  position = 'bottom-right',
  durationOrOptions = 3000
) {
  if (typeof window === 'undefined') return

  const options =
    typeof durationOrOptions === 'number'
      ? { durationMs: durationOrOptions }
      : durationOrOptions && typeof durationOrOptions === 'object'
        ? durationOrOptions
        : {}

  if (!text && !options.call) return

  const bus = window.$nuxt
  if (bus?.$emit) {
    bus.$emit('show-toast', text || '', type, position, options)
  }
}

/** Сообщение об ошибке из ответа API или fallback. */
export function getApiErrorMessage(error, fallback) {
  return error?.response?.data?.message || fallback
}
